module.exports = __webpack_public_path__ + "static/media/Detail_Icon_04_hovered.0d3c5b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Detail_Icon_04_hovered.png
// module id = 1579
// module chunks = 0